import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, ArrowRightIcon, ShoppingCartIcon, Typography } from '@ag1/ui';
import { useIsLoggedInValue } from '@portal/appLayer/auth';
import { useLocale } from '@portal/shared/hooks/useLocale';
import { LocaleEnum } from '@portal/schema/locale';
import { routes } from '@portal/constants/routes';
import { sendViewCartEvent } from 'analytics/events/ecommerce';
import { EMPTY_STATE_SHOP_LINK } from '../../constants';
import { useSiteCart } from '../../hooks/SiteCartContext';
import { SiteCartUpsell } from '../SiteCartUpsell/SiteCartUpsell';
import styles from './SiteCartEmptyState.module.scss';

export const SiteCartEmptyState = () => {
  const isLoggedIn = useIsLoggedInValue();
  const { t } = useTranslation('siteCart');
  const { closeCart } = useSiteCart();
  const locale = useLocale();
  const isUsLocale = locale === LocaleEnum.enUS;

  const handleClick = () => {
    if (!isUsLocale) closeCart();
  };

  useEffect(() => {
    sendViewCartEvent({
      checkoutType: 'unified',
      cartStatus: 'Empty'
    });
  }, []);

  return (
    <div className={styles.container}>
      <ShoppingCartIcon className={styles.icon} />
      <div className={styles.textContainer}>
        <Typography noPadding variant="portalSubtitle" size="2" weight="700" color="black-new">
          {t('emptyState.label')}
        </Typography>
        <Typography noPadding variant="body" size="2">
          {t('emptyState.subtitle')}
        </Typography>
      </div>

      {isLoggedIn && <SiteCartUpsell />}

      <Button
        className={styles.button}
        // TODO: remove conditional href when shop page is available in all locales
        href={isUsLocale ? EMPTY_STATE_SHOP_LINK : routes.offers}
        onClick={handleClick}
        variant="primary"
        size="medium"
        rounded
        icon={<ArrowRightIcon />}
        iconPosition="right">
        {t('emptyState.buttonLabel')}
      </Button>
    </div>
  );
};
